/**
 * Shows a fileupload component
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FileUpload from '../../../components/fileUpload/FileUpload';

class ProfileImageHandler extends PureComponent {
    static propTypes = {
        classes: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        profileId: PropTypes.number.isRequired,
        uploadBackground: PropTypes.func.isRequired,
        fieldName: PropTypes.string.isRequired,
    };

    onFileSubmit = (file) => {
        this.props.uploadBackground(this.props.profileId, {
            file,
            fieldName: this.props.fieldName,
        });
    };

    render() {
        return (
            <FileUpload
                classes={this.props.classes}
                inProgress={this.props.loading}
                onFileSubmit={this.onFileSubmit}
            >
                {this.props.loading ? 'Laster opp...' : this.props.children}
            </FileUpload>
        );
    }
}

export default ProfileImageHandler;
